export const STUDENTS_API = '/api/dashboard/customer/membership/students'
